import { useEffect } from 'react';
import { useColorScheme } from 'react-native';
import { DeviceTheme } from '../../api/api.g';
import { useAppDispatch, useAppSelector } from '../../hooks/store-hook';
import { userPrefsActions } from '../../store/userPrefsSlice';

// Follow OS/browser theme only when the user's selected preference is System.
const SystemThemeSync = () => {
  const colorScheme = useColorScheme(); // 'light' | 'dark' | null
  const dispatch = useAppDispatch();
  const currentTheme = useAppSelector((s) => s.userPrefs.theme);
  const themePreference = useAppSelector((s) => s.userPrefs.themePreference ?? DeviceTheme.System);

  useEffect(() => {
    if (themePreference !== DeviceTheme.System) {
      return;
    }

    const nextTheme = colorScheme === 'dark' ? DeviceTheme.Dark : DeviceTheme.Light;

    if (nextTheme !== currentTheme) {
      dispatch(userPrefsActions.syncThemeWithSystem(nextTheme));
    }
  }, [colorScheme, currentTheme, themePreference, dispatch]);

  return null;
};

export default SystemThemeSync;

